import { useState } from 'react';
import { RetrieveFlightBatchUpdateResponse } from '../models/PnrUpdateResponse';

export const usePnrUpdate = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [updateResponse, setUpdateResponse] = useState<RetrieveFlightBatchUpdateResponse | null>(null);

  const handlePnrUpdateResponse = (response: RetrieveFlightBatchUpdateResponse) => {
    setUpdateResponse(response);
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
    setUpdateResponse(null);
  };

  return {
    dialogOpen,
    updateResponse,
    handlePnrUpdateResponse,
    closeDialog,
  };
};
